import React from 'react';
import _ from 'lodash';

import Button from 'components/Button';
import ButtonDropdown from 'components/ButtonDropdown';
import arrowDown from 'assets/icons/sort-down-button.svg';
import arrowUp from 'assets/icons/sort-up-button.svg';

import './styles.css';

const CheckedButton = ({isOpened, showButton, hide, show, header}) => (
  <React.Fragment>
    {showButton && (
      <div className="checkedButton">
        {isOpened && (
          <Button white={true} onClick={hide}>
            {`${header} today`} <img src={arrowUp} alt="close" />
          </Button>
        )}
        {!isOpened && (
          <Button white={true} onClick={show}>
            {`${header} today`} <img src={arrowDown} alt="close" />
          </Button>
        )}
      </div>
    )}
  </React.Fragment>
);

const ExportButton = ({
  exportButtonTitle,
  exportDisabled,
  triggerExport,
  triggerExperimentalExport
}) => (
  <React.Fragment>
    {_.isNil(triggerExperimentalExport) && (
      <Button
        white
        className="exportButton"
        disabled={exportDisabled}
        onClick={triggerExport}>
        Export
      </Button>
    )}

    {!_.isNil(triggerExperimentalExport) && (
      <ButtonDropdown
        title="Export Options"
        disabled={exportDisabled}
        tooltip={exportDisabled && 'Cannot export'}
        menuPosition={ButtonDropdown.MENU_POSITION_BOTTOM}>
        <ButtonDropdown.Option
          onClick={triggerExport}
          disabled={exportDisabled}>
          {exportButtonTitle}
        </ButtonDropdown.Option>
        <ButtonDropdown.Option
          onClick={triggerExperimentalExport}
          disabled={exportDisabled}>
          Background Export
        </ButtonDropdown.Option>
      </ButtonDropdown>
    )}
  </React.Fragment>
);

const TableSplitter = ({
  isOpened,
  showSplitButton,
  triggerHide,
  triggerShow,
  splitButtonText,
  exportButtonTitle,
  exportDisabled,
  triggerExport,
  triggerExperimentalExport
}) => (
  <div className="TableSplitter">
    <ExportButton
      exportButtonTitle={exportButtonTitle}
      exportDisabled={exportDisabled}
      triggerExport={triggerExport}
      triggerExperimentalExport={triggerExperimentalExport}
    />
    <CheckedButton
      header={splitButtonText}
      isOpened={isOpened}
      show={triggerShow}
      hide={triggerHide}
      showButton={showSplitButton}
    />
  </div>
);

export default TableSplitter;
